import { Csat, SaveCsatProps } from 'types/csat'
import { create } from 'zustand'

interface CsatStorageType {
  initialRatingCsat: number
  csatToken: string | null
  csatData: Csat | null
  csatAnswer: SaveCsatProps | null
  setInitialRatingCsat: (rating: number) => void
  setCsatToken: (token?: string) => void
  setCsatData: (csatData?: Csat | null) => void
  setCsatAnswer: (csatAnswer?: SaveCsatProps | null) => void
  hasCsat: () => boolean
}

const initialState = {
  initialRatingCsat: 0,
  csatToken: null,
  csatData: null,
  csatAnswer: null
}

const useStorageCsat = create<CsatStorageType>((set, get) => ({
  ...initialState,
  setInitialRatingCsat: (rating: number) =>
    set({ initialRatingCsat: rating || 0 }),
  setCsatToken: (token?: string) => set({ csatToken: token }),
  setCsatData: (csatData?: Csat | null) => set({ csatData: csatData }),
  setCsatAnswer: (csatAnswer?: SaveCsatProps | null) =>
    set({ csatAnswer: csatAnswer }),
  hasCsat: () => {
    const csatData = get().csatData
    if (csatData && csatData !== undefined) {
      return true
    } else {
      return false
    }
  }
}))

export default useStorageCsat

